import React from "react";
import { usePageHeaderByKey } from "../hooks/usePageHeaderBykey";

export const InlineThankYouMessage = ({ preferredTitle, lastName, onSendAnother }) => {
  const { pageHeader, isLoading } = usePageHeaderByKey("thank-you");

  if (isLoading) {
    return null;
  }

  const content =
    pageHeader?.content != null && pageHeader.content.trim() !== ""
      ? null
      : (
          <>
            <p style={{ fontSize: "0.85rem", marginBottom: "8px" }}>
              Thank you for completing the form, {preferredTitle} {lastName}.
            </p>
            <p style={{ fontSize: "0.85rem", marginBottom: "8px" }}>
              We will get back to you as soon as possible.
            </p>
            <p style={{ fontSize: "0.85rem", marginBottom: "8px" }}>
              American Realty Network Team
            </p>
          </>
        );

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        padding: "16px",
        fontFamily: "Tahoma, sans-serif",
      }}
    >
      {pageHeader?.content ? (
        <div
          style={{ fontSize: "0.85rem", marginBottom: "12px", color: "#111827" }}
          dangerouslySetInnerHTML={{
            __html: pageHeader.content
              .replace(/\{preferredTitle\}/g, preferredTitle || "")
              .replace(/\{lastName\}/g, lastName || ""),
          }}
        />
      ) : (
        content
      )}
      {onSendAnother && (
        <button
          onClick={onSendAnother}
          style={{
            marginTop: "8px",
            background: "#BA1500",
            color: "#fff",
            border: "none",
            padding: "6px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "0.85rem",
          }}
        >
          Send Another Message
        </button>
      )}
    </div>
  );
}

